import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {map, take, tap} from 'rxjs/operators';
import * as fromAuth from '../reducers';
import {AbstractAuthGuardService} from './abstract-auth-guard.service';

@Injectable()
export class AnonymousAuthGuardService extends AbstractAuthGuardService {
    constructor(protected store: Store<fromAuth.AuthState>, private router: Router) {
        super();
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const url = state.url;
        console.log('Start AnonymousAuthGuard for', url);

        return this.determineIsLoggedIn().pipe(
            tap(isLoggedIn => console.log('AnonymousAuthGuard:: result:', !isLoggedIn)),
            tap(isLoggedIn => {
                if (isLoggedIn) {
                    this.router.navigate(['/']);
                }
            }),
            map(isLoggedIn => !isLoggedIn),
            take(1)
        );
    }
}
